module.exports = __webpack_public_path__ + "static/media/1634537575.a2a65035.jpg";